export default "__VITE_ASSET__DZbndWwR__"